<div class="layout-wrapper">
  <ng-content></ng-content>
  <app-footer></app-footer>
</div>
